import { configureStore } from '@reduxjs/toolkit';
import userData from './userSlice';
import errorData from './errorSlice';
import envData from './envSlice';
import coachingRequestManagementData from './coachingRequestManagementSlice';

const reducer = {
  userData,
  errorData,
  envData,
  coachingRequestManagementData,
};

export default configureStore({
  reducer,
});

export const generateStore = (preloadedState) => configureStore({
  reducer,
  preloadedState,
});
